import { FormEventHandler, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'
import { Input } from 'ui/input'
import { LoadingButton } from 'ui/loading-button'
import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import { LinkButton } from '~/components/link-button'
import { LS_JWT_KEY } from '~/const/api'
import { Route } from '~/routes/auth/reset-password'

import { AuthForm } from '../components/auth-form'

export const Reset = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { token } = Route.useSearch()
  const navigate = useNavigate()

  const { t } = useTranslation()

  const onSubmit: FormEventHandler = e => {
    e.preventDefault()
    setIsLoading(true)
    const password = ((e.currentTarget as HTMLFormElement).elements.namedItem('password') as HTMLInputElement).value
    if (!token) return toast.error(t('No token in the query'))

    if (!password) return

    void apiClient
      .POST('/auth/reset-password', {
        body: { password, token },
      })
      .then(({ data, response }) => {
        setIsLoading(false)
        if (response.status === 401) return toast.error(t('Broken reset link'))

        if (response.status >= 400) return toast.error(t('Something went wrong'))

        if (data?.jwtToken) {
          localStorage.setItem(LS_JWT_KEY, data?.jwtToken)

          void navigate({ to: '/list' })
        }
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <AuthForm onSubmit={onSubmit}>
      <Input name="password" placeholder={t('Password')} type="password" required />
      <LoadingButton isLoading={isLoading} type="submit">
        {t('Reset password')}
      </LoadingButton>
      <LinkButton to="/auth/login" variant="outline">
        {t('To login')}
      </LinkButton>
    </AuthForm>
  )
}
